import {BaseComponent} from "react-vextensions";
import {Row, Button, RowProps} from "react-vcomponents";
import {Icon} from "web-vcore";
import {Range, E} from "js-vextensions";
import React from "react";
import {observer_mgl} from "mobx-graphlink";

export const StarsRating = observer_mgl((props: {
	value: number, onChange: (value: number|null)=>any, allowRightClickFor0?: boolean,
	/** if set, title-text is set to "Set $attribute to ? stars (?%) [right-click for 0; again to clear]") */
	titleFunc_attribute?: string,
	titleFunc?: (starValue: number)=>string,
} & Omit<RowProps, "onChange">)=>{
	const {
		value, onChange,
		titleFunc_attribute,
		titleFunc = starValue=>{
			return `Set ${titleFunc_attribute ?? ""} to ${starValue} stars (${starValue * 20}%) [right-click for 0; again to clear]`.replace("  ", " ");
		},
		allowRightClickFor0 = true,
		...rest
	} = props;
	return (
		<Row {...rest} style={{alignItems: "center"}}>
			{Range(1, 5).map(starValue=>{
				return (
					/*<Button key={starValue} text={<Icon icon="Star" size={15} style={E(value < starValue && {filter: "grayscale"})}/>} title={`Set rating to ${starValue} stars`} onClick={()=>{
						onChange(starValue);
					}}/>*/
					<Icon key={starValue} divContainer={true} icon="Star" size={15}
						divProps={{
							style: E(
								{cursor: "pointer"},
								!(value >= starValue) && {filter: "grayscale(1)"},
							),
							title: titleFunc?.(starValue) ?? null,
							onClick: e=>{
								// workaround for onClick double-fire bug in Icon comp (remove once updated to version with fix)
								if (e["lf-handled"]) return;
								e["lf-handled"] = true;

								onChange(starValue);
							},
							onContextMenu: e=>{
								// workaround for onClick double-fire bug in Icon comp (remove once updated to version with fix)
								if (e["lf-handled"]) return;
								e["lf-handled"] = true;

								if (!allowRightClickFor0) return;
								e.preventDefault();
								onChange(value != null && value != 0 ? 0 : null);
							},
						}}/>
				);
			})}
		</Row>
	);
});